import React, { useState, useCallback } from "react";
import { NotificationContext } from "./NotificationContext";
import NotificationContainer from "./NotificationContainer";

export default function NotificationProvider({ children }) {
  const [notifications, setNotifications] = useState([]);

  const removeNotification = useCallback((id) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id));
  }, []);

  const notify = useCallback((type, message, title) => {
    const id = Date.now();
    setNotifications((prev) => [
      ...prev,
      { id, type, message, title }
    ]);
    setTimeout(() => removeNotification(id), 3000); // Auto hide in 3 sec
  }, [removeNotification]);

  const notifyApi = {
    success: (msg) => notify("success", msg, "Success"),
    error: (msg) => notify("error", msg, "Error"),
    info: (msg) => notify("info", msg, "Info"),
    warn: (msg) => notify("warn", msg, "Warning"),
  };

  return (
    <NotificationContext.Provider value={notifyApi}>
      {children}
      <NotificationContainer
        notifications={notifications}
        onRemove={removeNotification}
      />
    </NotificationContext.Provider>
  );
}
